import { QueryClient } from '@tanstack/vue-query'

/**
 * Passed explicitly to every useQuery/useQueries call in a Pinia store, since
 * a store's setup() doesn't always run inside a component's injection
 * context (e.g. a store-only unit test with no mounted app). Relying on
 * VueQueryPlugin's provide/inject there throws "No 'queryClient' found".
 */
export const queryClient = new QueryClient()
